export const ProposalsColumns = [
    {
        name: 'Клиент',
        key: 'name',
    },
    {
        name: 'Номер телефона',
        key: 'phoneNumber',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]
